import { fetchApi } from '@/config/axiosSetting';
import {
  GetCulpritVehicleInformationType,
  getCulpritVehicleInformationType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritVehicleInformation/getCulpritVehicleInformation.type';

export const getCulpritVehicleInformationFunction = ({
  id,
}: getCulpritVehicleInformationType): Promise<GetCulpritVehicleInformationType> => {
  return fetchApi.get(
    `/property/reports/${id}/accident_users/culprit/vehicle_information/`,
  );
};
